import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICourseCategory } from "../../../Pages/CourseCategory/ICourseCategory";

export const ListCourseCategorySlice = createSlice({
  name: "ListCourseCategorySlice",
  initialState: {} as IReduxState<ICourseCategory[]>,
  reducers: {
    listCourseCategory: (state) => {
      state.isLoading = true;
    },
    successlistCourseCategory: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistCourseCategory: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistCourseCategory, listCourseCategory, successlistCourseCategory } =
  ListCourseCategorySlice.actions;

export default ListCourseCategorySlice.reducer;
